import React from 'react';
import styles from './upgrade-your-plan-bullets.module.scss';
import {
    Button,
    FlexContainer,
    Heading,
    Icon,
    IconContainer,
    MenuText,
} from '@placer-ui/components';
import { useAppUiActions } from 'store/app-ui/use-app-ui-actions';
import { UPGRADE_PLAN_SCREEN } from 'extensions/upgrade-your-plan-dialog/upgrade-your-plan-dialog';
import { useSplunkCallback } from 'hooks/use-splunk-callback/use-splunk-callback';

const BULLETS = [
    {
        label: 'More Chains',
        description: 'Foot-traffic data for hundreds of chains',
        iconType: 'Chain',
    },
    {
        label: 'Historical Data',
        description: 'Data going back 7 years',
        iconType: 'CalendarDots',
    },
    {
        label: 'Additional Reports',
        description: 'Deeper analysis with more metrics, insights and views',
        iconType: 'Note',
    },
];

export const UpgradeYourPlanBullets = () => {
    const sendEvent = useSplunkCallback();
    const { openUpgradePlanPopup, closeUpgradePlanPopup } = useAppUiActions();

    const handleConsultWithSalesClick = () => {
        openUpgradePlanPopup(UPGRADE_PLAN_SCREEN.consultForm);
        sendEvent({
            component: 'upgrade-your-plan-popup',
            action: 'button-click',
            btn_name: 'consult-with-sales',
        });
    };

    return (
        <>
            <ul className={styles.bullets}>
                {BULLETS.map((bullet) => (
                    <li key={bullet.label} className={styles.item}>
                        <IconContainer shape={'circle'} color={'gray'} size={48}>
                            <Icon type={bullet.iconType} size={32} />
                        </IconContainer>
                        <div>
                            <Heading variant={'h4'}>{bullet.label}</Heading>
                            <MenuText>{bullet.description}</MenuText>
                        </div>
                    </li>
                ))}
            </ul>
            <FlexContainer
                flexDirection={'column'}
                alignItems={'center'}
                gap={'12px'}
                className={styles.actions}
            >
                <Button
                    fullWidth
                    variant={'primary-brand'}
                    testId={'consult-with-sales-button'}
                    size={'large'}
                    onClick={handleConsultWithSalesClick}
                >
                    Consult with Sales
                </Button>
                <Button
                    fullWidth
                    variant={'text'}
                    testId={'close-upgrade-plan-button'}
                    size={'large'}
                    onClick={closeUpgradePlanPopup}
                >
                    Close
                </Button>
            </FlexContainer>
        </>
    );
};
